export default "__VITE_ASSET__XuDAY6IM__"